'use strict';
var alreadyInit = false;
var sys = {
	width: 0,
	height: 0,
	isMobile: false,
	hash: '',
	init: function() {
		sys.gethash();
		sys.mobileDetect();
		// for mobile
		if (sys.isMobile) {
			$('html').addClass('bp-touch');
		}
		sys.mobile();

		// sys.loader('init');
		sys.resize();

		$('[select-box]').each(function(index) {
			var _class = 'selectbox' + index;
			$(this).addClass(_class);

			sys.selectBox({
				target: '.' + _class
			});
		});

		sys.sysBoxes({
			target: '.com_sy-boxes'
		});

		// sys.sysSearch({
		// 	target: '.com_sy-search'
		// });
	},
	ready: function() {
		sys.resize();
		// hide the preloader
		// sys.loader('close');

		// for popup
		$('[data-fancybox]').fancybox({
			animationEffect: 'zoom-in-out',
			clickSlide: false,
			clickOutside: false,
			autoFocus: false,
			touch: false,
			btnTpl: {
				smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' + '<img src="assets/img/close.png" width="15" alt="">' +"</button>"
			},
			afterShow: function() {
				sys.resize();
			}
		});

		// for auto popup
		if(sys.hash) {
			var _hash = document.querySelector('[data-fancybox][href="'+sys.hash+'"]');
			$(_hash).trigger('click');
		}

		// close fancybox
		$('.fancybox-close').click(function(e) {
			e.preventDefault();
			$.fancybox.close();
		});
	},
	loader: function(state) {
		var _loader = {
			content: '',
			init: function() {
				_loader.content = '<div class="bp-preloader"><div class="spinner"><span class="s-dot s-dot1"></span><span class="s-dot s-dot2"></span></div></div>';
				$('body').prepend(_loader.content);
			},
			close: function() {
				$('.bp-preloader').fadeOut();
			}
		}

		if(state == 'init') {
			_loader.init();
		} else if(state == 'close') {
			_loader.close();
		}
	},
	resize: function() {
		var _resize = {
			init: function() {
				sys.width = $(window).outerWidth();
				sys.height = $(window).outerHeight();

				// STICKY FOOTER
				var headerHeight = $('header').outerHeight(),
				footerHeight = $('footer').outerHeight(),
				footerTop = (footerHeight) * -1;
				var footer = document.querySelector('footer'),
				mainWrapper = document.querySelector('#main-wrapper'),
				hocoBottom = document.querySelector('.ho-co-bottom');
				
				// FOOTER
				$('footer').css({marginTop: footerTop});
				$('#main-wrapper').css({paddingBottom: footerHeight});
				$('#main-wrapper').css('padding-top', headerHeight + 'px');
				$('#main-wrapper').css('padding-bottom', ($('.ho-co-bottom').outerHeight()) + 'px');
				// mainWrapper.style.paddingBottom =x (;
				// FOOTER END

				// for equal height
				sys.equalize($('.classname'));

				if($('body').hasClass('sy-ch-content')) {
					var _headerHeight = $('.sy-ch-header').outerHeight();
					$('#main-wrapper').css({paddingTop: _headerHeight});

					var _sysBottomHeight = $('.sy-ch-bottom').outerHeight();
					$('.sy-ch-main').css({paddingBottom: _sysBottomHeight + 15});
				}
			}
		}
		_resize.init();
	},
	equalize: function(target) {
		$(target).css({minHeight: 0});
		var _biggest = 0;
		for ( var i = 0; i < target.length ; i++ ){
			var element_height = $(target[i]).outerHeight();
			if(element_height > _biggest ) _biggest = element_height;
		}
		$(target).css({minHeight: _biggest});
		return _biggest;
	},
	gethash: function() {
		sys.hash = window.location.hash;
	},
	mobileDetect: function() {
		var isMobile = {
			Android: function() {
				return navigator.userAgent.match(/Android/i);
			},
			BlackBerry: function() {
				return navigator.userAgent.match(/BlackBerry/i);
			},
			iOS: function() {
				return navigator.userAgent.match(/iPhone|iPad|iPod/i);
			},
			Opera: function() {
				return navigator.userAgent.match(/Opera Mini/i);
			},
			Windows: function() {
				return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
			},
			any: function() {
				return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
			}
		};
		if(isMobile.any) {
			sys.isMobile = isMobile.any();
		}
	},
	selectBox: function(opt) {
		var _select = {
			target: '',
			box: '',
			title: '',
			list: '',
			lis: '',
			current: 0,
			init: function() {
				_select.defaults();
				_select.create();
				_select.clicks();
			},
			defaults: function() {
				_select.target = document.querySelector(opt.target);
				_select.box = _select.target.querySelector('select');

				// if mobile, use native select box
				if(sys.isMobile && window.innerWidth < 1020) {
					_select.target.classList.add('select-mobile');
				} else {
					_select.box.style.display = "none";
				}
			},
			create: function() {
				// create title
				_select.title = document.createElement('div');
				_select.title.classList.add('com__sb-title');

				// create list
				_select.list = document.createElement('ul');
				_select.list.classList.add('com__sb-list');

				var _options = _select.box.querySelectorAll('option');
				for (var i = 0; i < _options.length; i++) {
					var _entry = document.createElement('li');
					_entry.setAttribute('select-number', i);

					// target the selected option
					if(_options[i].selected) {
						_select.current = i;
						_entry.classList.add('selected');
					}

					// put the text
					_entry.innerHTML = _options[i].textContent;

					// put the entry to list
					_select.list.appendChild(_entry);
				}

				// append the containers
				_select.target.appendChild(_select.title);
				_select.target.appendChild(_select.list);
			},
			clicks: function() {
				// when clicking title
				_select.title.addEventListener('click', function(event) {
					_select.target.classList.toggle('selected');

					var _tooLow = $(window).outerHeight() * 0.75;
					if(event.clientY > _tooLow) {
						_select.target.classList.toggle('box-upward');
					}
				});

				// when click lists
				_select.lis = _select.list.querySelectorAll('li');
				for (var i = 0; i < _select.lis.length; i++) {
					_select.lis[i].addEventListener('click', function() {
						var _num = this.getAttribute('select-number');

						_select.update(_num);
						_select.close();
					});
				}

				// trigger the current select option
				_select.lis[_select.current].click();

				// for native select box
				_select.box.addEventListener('change', function() {
					var _num = _select.box.options.selectedIndex;

					_select.update(_num);
					_select.close();
				});

				// when click outside the checkbox
				window.addEventListener('click', function(e){   
					if ((document.querySelector(opt.target) != null)){
						if (!(document.querySelector(opt.target).contains(e.target))){
							_select.close();
						}
					}
				});
			},
			update: function(number) {
				// put class on the selected li
				for (var i = 0; i < _select.lis.length; i++) {
					_select.lis[i].classList.remove('selected');
				}
				_select.lis[number].classList.add('selected');

				// make active the selectec option
				_select.box.options.selected = false;
				_select.box.options[number].selected = true;

				// update the text of the titles
				_select.title.innerHTML = '';
				_select.title.innerHTML = _select.lis[number].textContent;
			},
			close: function() {
				_select.target.classList.remove('box-upward');
				_select.target.classList.remove('selected');
			}
		}
		_select.init();
	},
	sysBoxes: function(opt) {
		var _box = {
			target: '',
			init: function() {
				_box.target = document.querySelector(opt.target);
				// $('.sy-ml-box', _box.target).click(function() {
				// 	var _this = $(this);

				// 	if(_this.hasClass('selected')) {
				// 		_this.removeClass('selected');
				// 	} else {
				// 		$('.sy-ml-box', _box.target).removeClass('selected');
				// 		_this.addClass('selected');
				// 	}
				// });
			}
		}
		_box.init();
	},
	sysSearch: function(opt) {
		var _search = {
			target: '',
			init: function() {
				_search.target = document.querySelector(opt.target);

				// $('.form-control', _search.target).on('keydown', function(e) {
				// 	if(e.keyCode == 13) {
				// 		_search.open();
				// 	}
				// });

				// $('.sy-se-icon', _search.target).click(function() {
				// 	_search.open();
				// });
			},
			open: function() {
				$.fancybox.open({
					src: '#search-result',
					animationEffect: 'zoom-in-out',
					clickSlide: false,
					clickOutside: false,
					autoFocus: false,
					touch: false,
					btnTpl: {
						smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' + '<img src="assets/img/close.png" width="15" alt="">' +"</button>"
					},
					afterShow: function() {
						scanda.resize();
					}
				});
			}
		}
		_search.init();
	},
	mobile: function() {
		var _mobile = {
			bar: '',
			cover: '',
			main: '',
			init: function() {
				_mobile.bar = $('.menu-bar');
				_mobile.cover = $('.menu-mobile.cover');
				_mobile.main = $('.menu-mobile.main');

				_mobile.bar.off();
				_mobile.cover.off();
				_mobile.main.off();

				_mobile.bar.click(function() {
					var _this = $(this);

					if(_this.hasClass('active')) {
						_mobile.menuClose();
					} else {
						_mobile.menuOpen();
					}
				});

				$('.menu li a', _mobile.main).click(function() {
					_mobile.menuClose();
				});

				_mobile.cover.click(function() {
					_mobile.menuClose();
				});
				alreadyInit = true;
			},
			menuOpen: function() {
				_mobile.bar.addClass('active');
				_mobile.cover.fadeIn(200);
				_mobile.main.slideDown(200);
				$('html').addClass('menu-mobile-active');
			},
			menuClose: function() {
				_mobile.bar.removeClass('active');
				_mobile.cover.fadeOut(200);
				_mobile.main.slideUp(200);
				$('html').removeClass('menu-mobile-active');
			}
		}
		_mobile.init();
	}
}
sys.init();

$(document).ready(function() {
	sys.ready();
});

$(window).resize(function() {
	sys.resize();
});

var runAll = function(){
	sys.init();

	$(document).ready(function() {
		sys.ready();
	});

	$(window).resize(function() {
		sys.resize();
		clearTimeout(sys.resizeTimer);
		sys.resizeTimer = setTimeout(function() {
			sys.resize();
		}, 400);
	});
}

export default{
	sys,
	runAll
}


// WEBPACK FOOTER //
// ./src/assets/js/custom.js